import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    makeStyles,
    Typography,
    Button
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

export default function Popup(props) {
    const {title, children, openPopup, setOpenPopup, width = '60%', height = 'auto', maxWidth = 'lg', onClose} = props;
    const classes = useStyles({ width, height });

    const handleClose = () => {
        if (setOpenPopup) setOpenPopup(false);
        if (onClose) onClose();
    }

    return (
        <Dialog open={openPopup} onClose={handleClose} maxWidth={maxWidth} classes={{paper: classes.dialogWrapper}}
        BackdropProps={{ style:{
            backdropFilter: 'blur(3px)',
            
        }}}>
            <DialogTitle className={classes.dialogTitle}>
                <div style={{ display: 'flex' }}>
                    <Typography variant="h6" component="div" style={{flexGrow: 1}}>
                        {title}
                    </Typography>
                    <Button color="secondary" onClick={handleClose} aria-label="Fechar">
                        <CloseIcon />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent dividers>
                {children}
            </DialogContent>
        </Dialog>
    )
}

const useStyles = makeStyles(theme => ({
    dialogWrapper: {
        width: ({ width }) => width,
        height: ({ height }) => height,
        maxWidth: 'calc(100vw - 32px)',
        borderRadius: 16,
        boxShadow: '0 24px 64px rgba(15, 23, 42, 0.18)',
    },
    dialogTitle: {
        padding: theme.spacing(2, 3),
        borderBottom: '1px solid #e5e7eb',
        '& h6': { color: '#1e293b', fontWeight: 700 },
        '& + .MuiDialogContent-root': { padding: theme.spacing(3) },
    },
}))
